module.exports = __webpack_public_path__ + "ipetbooking/admin/img/cog.79299073.svg";